import styled from '@emotion/styled';

import {
  animation,
  breakpoints,
  colors,
  fontWeight,
} from '@datacamp/waffles-tokens';

export const A = styled.a`
  color: ${props =>
    props.colors === 'darkOnLight' ? colors.grey : colors.white};
  font-weight: ${fontWeight.regular};
  transition: opacity ${animation.transition};

  &:active,
  &:focus,
  &:hover {
    border-color: transparent;
    color: ${props =>
      props.colors === 'darkOnLight' ? colors.grey : colors.white};
    opacity: 0.9;
  }
`;

export const Trigger = styled.button`
  align-items: center;
  background: none;
  border: 0;
  box-shadow: none;
  color: ${props =>
    props.colors === 'darkOnLight' ? colors.grey : colors.white};
  display: inline-flex;
  transition: opacity ${animation.transition};

  .icon {
    color: ${props =>
      props.colors === 'darkOnLight'
        ? colors.greyOslo
        : colors.white}; /* Workaround for Waffles Icon props */
    margin-left: 4px; /* DS violation to match current design, which looks better */
  }
`;

export const Links = styled.div`
  display: none;

  > a {
    margin-left: 32px;

    &.create {
      margin-left: 16px;
    }
  }

  @media screen and (min-width: ${breakpoints.md}) {
    display: block;
  }
`;
